import { React, Component } from "react";

class Flags extends Component {
    state = {
        data: this.props.data
    };

    render() {
        const { data } = this.state;

        function animateNumbers(start, end, id) {
            const step = Math.abs(end - start) / 100;
            const increment = start < end ? step : -step;
        
            const updateNumber = () => {
                if ((increment > 0 && start >= end) || (increment < 0 && start <= end)) {
                    document.getElementById(id).innerHTML = end.toLocaleString()+'<span>km</span>'; // Format the end number as needed
                } else {
                    document.getElementById(id).innerHTML = Math.floor(start).toLocaleString()+'<span>km</span>'; // Round to remove decimal places
                    start += increment;
                    setTimeout(updateNumber, 20); // Adjust speed if needed
                }
            };
            updateNumber();
        }

        const getCar = async(dolphin_avg_ev_range, seal_avg_ev_range, sealudmi_avg_ev_range) => {
            const car = document.getElementById('car').value;

            const images = document.querySelectorAll('.car-img');
            for (let i = 0; i < images.length; i++){
                images[i].classList.remove('active');
            }
            document.getElementById(car).classList.add('active');

            const graphs = document.querySelectorAll('.graph');
            for (let i = 0; i < graphs.length; i++){
                graphs[i].classList.remove('active');
            }

            if(car === 'byd-dolphin'){
                document.getElementById('per_charge').innerHTML = 'Por carga (BYD Dolphin)';
                document.getElementById('graph-dolphin').classList.add('active');
                document.getElementById('avg_ev_range_title').innerHTML = 'Distancia media del vehículo eléctrico';
                animateNumbers(0, dolphin_avg_ev_range, "avg_ev_range");
            }

            if(car === 'byd-seal'){
                document.getElementById('per_charge').innerHTML = 'Por carga (BYD Seal)';
                document.getElementById('graph-seal').classList.add('active');
                document.getElementById('avg_ev_range_title').innerHTML = 'Distancia media del vehículo eléctrico';
                animateNumbers(0, seal_avg_ev_range, "avg_ev_range");
            }

            if(car === 'byd-sealudmi'){
                document.getElementById('per_charge').innerHTML = 'Rango total (BYD Seal U DM-i)';
                document.getElementById('graph-sealudmi').classList.add('active');
                document.getElementById('avg_ev_range_title').innerHTML = 'Gama combinada';
                animateNumbers(0, sealudmi_avg_ev_range, "avg_ev_range");
            }
        }

        const scroll = async() => {
            document.getElementById('flags').scrollIntoView({
                block: 'start',
                behavior: 'smooth'
            });
        }

        const dolphin_avg_ev_range = 426.5;
        const seal_avg_ev_range = 570;
        const sealudmi_avg_ev_range = 1080;

        const countryStats = async(pos, country_name, distance_total, distance_per_game, dolphin_avg_ev_range, seal_avg_ev_range, sealudmi_avg_ev_range) => {
            const dolphin_arr = [distance_total, distance_per_game, dolphin_avg_ev_range];
            dolphin_arr.sort(function(a, b) {
                return a - b;
            });
            const dolphin_highest = dolphin_arr.slice(-1);
            const dolphin_distance_total_perc = distance_total / dolphin_highest * 100;
            const dolphin_distance_per_game_perc = distance_per_game / dolphin_highest * 100;
            const dolphin_avg_range_perc = dolphin_avg_ev_range / dolphin_highest * 100;

            const seal_arr = [distance_total, distance_per_game, seal_avg_ev_range];
            seal_arr.sort(function(a, b) {
                return a - b;
            });
            const seal_highest = seal_arr.slice(-1);
            const seal_distance_total_perc = distance_total / seal_highest * 100;
            const seal_distance_per_game_perc = distance_per_game / seal_highest * 100;
            const seal_avg_range_perc = seal_avg_ev_range / seal_highest * 100;

            const sealudmi_arr = [distance_total, distance_per_game, sealudmi_avg_ev_range];
            sealudmi_arr.sort(function(a, b) {
                return a - b;
            });
            const sealudmi_highest = sealudmi_arr.slice(-1);
            const sealudmi_distance_total_perc = distance_total / sealudmi_highest * 100;
            const sealudmi_distance_per_game_perc = distance_per_game / sealudmi_highest * 100;
            const sealudmi_avg_range_perc = sealudmi_avg_ev_range / sealudmi_highest * 100;

            document.getElementById('country-name').innerHTML = `<h2 class="pos-${pos}"><span id="flag" style="background-image: url('/content/dam/byd-site/eu/ev-range-vs-footballer-endurance/images/flags/${country_name.replace('ü', 'u').replace(/ /g, '_')}.svg')"></span>${country_name}</h2>`;

            document.getElementById('graph-dolphin').innerHTML = `<ul><li class="distance_total_bar"><span class="title">Distancia total</span><div class="bar"><div style="width:${dolphin_distance_total_perc}%" class="line"><div class="stat">${distance_total} <span>km</span></div></div></div></li><li class="distance_per_game_bar"><span class="title">Distancia media</span><div class="bar"><div style="width:${dolphin_distance_per_game_perc}%" class="line"><div class="stat">${distance_per_game} <span>km</span></div></div></div></li><li class="avg_ev_range_bar"><span class="title">Distancia media del vehículo eléctrico</span><div class="bar"><div style="width:${dolphin_avg_range_perc}%" class="line dolphin"><div class="stat">${dolphin_avg_ev_range} <span>km</span></div></div></div></li></ul>`;

            document.getElementById('graph-seal').innerHTML = `<ul><li class="distance_total_bar"><span class="title">Distancia total</span><div class="bar"><div style="width:${seal_distance_total_perc}%" class="line"><div class="stat">${distance_total} <span>km</span></div></div></div></li><li class="distance_per_game_bar"><span class="title">Distancia media</span><div class="bar"><div style="width:${seal_distance_per_game_perc}%" class="line"><div class="stat">${distance_per_game} <span>km</span></div></div></div></li><li class="avg_ev_range_bar"><span class="title">Distancia media del vehículo eléctrico</span><div class="bar"><div style="width:${seal_avg_range_perc}%" class="line seal"><div class="stat">${seal_avg_ev_range} <span>km</span></div></div></div></li></ul>`;

            document.getElementById('graph-sealudmi').innerHTML = `<ul><li class="distance_total_bar"><span class="title">Distancia total</span><div class="bar"><div style="width:${sealudmi_distance_total_perc}%" class="line"><div class="stat">${distance_total} <span>km</span></div></div></div></li><li class="distance_per_game_bar"><span class="title">Distancia media</span><div class="bar"><div style="width:${sealudmi_distance_per_game_perc}%" class="line"><div class="stat">${distance_per_game} <span>km</span></div></div></div></li><li class="avg_ev_range_bar"><span class="title">Gama combinada</span><div class="bar"><div style="width:${sealudmi_avg_range_perc}%" class="line sealudmi"><div class="stat">${sealudmi_avg_ev_range} <span>km</span></div></div></div></li></ul>`;

            animateNumbers(0, distance_total, "distance_total");
            animateNumbers(0, distance_per_game, "distance_per_game");
            animateNumbers(0, dolphin_avg_ev_range, "avg_ev_range");

            const graphs = document.querySelectorAll('.graph');
            for (let i = 0; i < graphs.length; i++){
                graphs[i].classList.remove('active');
            }
            document.getElementById('per_charge').innerHTML = 'Por carga (BYD Dolphin)';
            document.getElementById('graph-dolphin').classList.add('active');

            const images = document.querySelectorAll('.car-img');
            for (let i = 0; i < images.length; i++){
                images[i].classList.remove('active');
            }
            document.getElementById('byd-dolphin').classList.add('active');
            document.getElementById('car').value = 'byd-dolphin';

            document.getElementById('country').classList.add('active');
            document.getElementById('scroll').classList.remove('hidden');     
            
            document.getElementById('country').scrollIntoView({
                block: 'start',
                behavior: 'smooth'
            });
        }

        const countries = data.sort((a, b) => a.country_name > b.country_name ? 1 : -1).map((country, start = 0) => {
            return (
                <div className="country" key={country.country_id} style={{animationDelay: start * 0.10+'s'}}>
                    <input type="radio" name="country" id={country.country_id} value={country.country_id} autoComplete="off" />
                    <label htmlFor={country.country_id} onClick={() => { countryStats(country.country_id, country.country_name, country.distance_total, country.distance_per_game, dolphin_avg_ev_range, seal_avg_ev_range, sealudmi_avg_ev_range) }}>
                        <span className={'icon pos-'+country.country_id} style={{backgroundImage: `url('/content/dam/byd-site/eu/ev-range-vs-footballer-endurance/images/flags/${country.country_name.replace('ü', 'u').replace(/ /g, '_')}.svg')`}}></span>
                        <span className="title">{country.country_name}</span>
                    </label>
                </div>
            )
        });
        
        return (
            <div className="countries">
                <div id="flags">
                    <div className="container" data-animate-in="fade">
                        <p> Selecciona un país:</p>
                    </div>
                    <div className="container" data-animate-in="fade">
                        {countries}
                    </div>
                </div>

                <div id="country">
                    <div className="container">
                        <div id="country-name"></div>
                        <div className="country-stats">
                            <div className="stat stat-3">
                                <div id="car-picker" className="car-picker">
                                    <select className="car-select" id="car" onChange={() => { getCar(dolphin_avg_ev_range, seal_avg_ev_range, sealudmi_avg_ev_range) }}>
                                        <option value="byd-dolphin">BYD DOLPHIN</option>
                                        <option value="byd-seal">BYD SEAL</option>
                                        <option value="byd-sealudmi">BYD SEAL U DM-i</option>
                                    </select>
                                    <img id="byd-dolphin" className="car-img active" src="/content/dam/byd-site/eu/ev-range-vs-footballer-endurance/images/BYD_Dolphin_car.png" alt="BYD Dolphin" height="145" width="81" />
                                    <img id="byd-seal" className="car-img" src="/content/dam/byd-site/eu/ev-range-vs-footballer-endurance/images/BYD_Seal_car.png" alt="BYD Seal" height="145" width="81" />
                                    <img id="byd-sealudmi" className="car-img" src="/content/dam/byd-site/eu/ev-range-vs-footballer-endurance/images/BYD_Seal_U_DMi_car.png" alt="BYD Seal U DM-i" height="145" width="81" />
                                </div>
                                <div className="stat-content">
                                    <strong id="avg_ev_range_title">Distancia media del vehículo eléctrico</strong>
                                    <div id="avg_ev_range"><span>km</span></div>
                                    <span id="per_charge"></span>
                                </div>
                            </div>
                            <div className="stat stat-2">
                                <img src="/content/dam/byd-site/eu/ev-range-vs-footballer-endurance/images/stat-2.png" alt="Distancia por partido" height="67" width="76" className="img" />
                                <div className="stat-content">
                                    <strong>Distancia</strong>
                                    <div id="distance_per_game"><span>km</span></div>
                                    <span>Por partido</span>
                                </div>
                            </div>
                            <div className="stat stat-1">
                                <img src="/content/dam/byd-site/eu/ev-range-vs-footballer-endurance/images/stat-1.png" alt="Distancia total cubierta" height="83" width="95" className="img" />
                                <div className="stat-content">
                                    <strong>Distancia</strong>
                                    <div id="distance_total"><span>km</span></div>
                                    <span>A lo largo del torneo</span>
                                </div>
                            </div>
                        </div>
                        <div className="graph active" id="graph-dolphin"></div>
                        <div className="graph" id="graph-seal"></div>
                        <div className="graph" id="graph-sealudmi"></div>
                    </div>
                
                    <div id="scroll" className="hidden">
                        <div className="container" data-animate-in="fade">
                            <button onClick={() => { scroll() }} aria-label="Scroll to Flags">Selecciona un país distinto</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Flags;